import { IconType } from "react-icons";
import styled from "styled-components";
import { colors, fonts } from "../../../constants/constants";

const Container = styled.a.attrs((props: { margin: boolean }) => props)`
  margin-top: ${(props) => (props.margin ? "2rem" : "0")};
  margin-bottom: ${(props) => (props.margin ? "2rem" : "0")};

  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;

  padding: 0.5rem 1rem;
  border: solid 2px ${colors.primary};
  background-color: transparent;
  border-radius: 3px;

  transition: all 0.4s ease-in-out;

  font-family: ${fonts.primary.regular};
  color: ${colors.primary};

  svg {
    margin-left: 1rem;
    width: 2rem;
    margin-top: -0.2rem;
    color: ${colors.primary};
    transition: all 0.4s ease-in-out;
  }

  &:hover {
    background-color: ${colors.primary};
    color: #fff;

    svg {
      color: white;
    }
  }
`;

export interface CtaProps {
  href: string;
  Icon?: IconType;
  text: string;
  margin?: boolean;
  target?: string;
}

function Cta({ href, Icon, text, margin = true, target }: CtaProps) {
  return (
    <Container
      href={href ? href : ""}
      margin={margin}
      target={target ? target : ""}
    >
      <span>{text}</span>
      {Icon && <Icon fontSize="1.5rem" />}
    </Container>
  );
}

export default Cta;
